module.exports = __webpack_public_path__ + "static/media/GelBoxFullBufferOpen.74793113.svg";